export const SITE_NAME = 'sprancer.com';
export const SUPPORT_EMAIL = 'support@sprancer.com';
export const API_NAME = 'sprancer-api';
export const ANDROID_PUSH_DEFAULT_CHANNEL_ID = 'default';
export const ANDROID_PUSH_SILENT_CHANNEL_ID = 'silent';
export const SPRANCER_APP_STORE_URL = 'https://apps.apple.com/us/app/sprancer/id1545872777';
export const SPRANCER_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.sprancer.app';
export const SPRANCER_BIZ_APP_STORE_URL = 'https://apps.apple.com/us/app/sprancer-business/id1563761016';
export const SPRANCER_BIZ_PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.sprancer.biz';
//# sourceMappingURL=constants.js.map